///<reference path="../../employee/sections/employee.bookingRestrictions.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class BookingRestrictionsSection extends Meevo.Plugins.Employee.BookingRestrictionsSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherBookingRestriction;
        }
    }
}